/**
 * Pasting into number boxes.
 *
 * A browser silently drops a paste into an <input type="number"> unless the
 * text is a bare number — so "1,200", "5 kg", "£12.50" or a value copied
 * from a spreadsheet cell with a trailing space came through as nothing.
 * One listener for the whole app: tidy the pasted text into a plain number
 * and put it in the box the way React expects (so the form state updates).
 */

export function cleanNumber(text) {
  let t = String(text ?? '').trim().replace(/[  \s]/g, '');
  const m = t.match(/-?\d[\d,.]*|-?\.\d+/);
  if (!m) return null;
  t = m[0];
  const commas = (t.match(/,/g) || []).length;
  const dots = (t.match(/\./g) || []).length;
  if (commas && dots) {
    // "1,234.56" (commas are thousands) or "1.234,56" (dots are thousands)
    t = t.lastIndexOf('.') > t.lastIndexOf(',') ? t.replace(/,/g, '') : t.replace(/\./g, '').replace(',', '.');
  } else if (commas === 1 && !/,\d{3}$/.test(t)) {
    t = t.replace(',', '.');           // "2,5" → 2.5
  } else {
    t = t.replace(/,/g, '');           // "1,200" / "1,200,000"
  }
  if (!/^-?(\d+\.?\d*|\.\d+)$/.test(t)) return null;
  return t.replace(/\.$/, '');
}

export function installNumberPaste() {
  document.addEventListener('paste', (e) => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement) || el.type !== 'number') return;
    const text = e.clipboardData?.getData('text');
    if (text == null) return;
    const clean = cleanNumber(text);
    if (clean == null || clean === text.trim()) return; // nothing to fix — let the browser paste
    e.preventDefault();
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(el, clean);
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
}
